import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressOverview = ({ totalTasks, completedTasks, totalXP, earnedXP }) => {
  const completionPercentage = totalTasks > 0 ? Math.round((completedTasks / totalTasks) * 100) : 0;
  const xpPercentage = totalXP > 0 ? Math.round((earnedXP / totalXP) * 100) : 0;

  const milestones = [
    { threshold: 25, label: 'Getting Started', icon: 'Rocket', reached: completionPercentage >= 25 },
    { threshold: 50, label: 'Halfway There', icon: 'TrendingUp', reached: completionPercentage >= 50 },
    { threshold: 75, label: 'Almost Done', icon: 'Target', reached: completionPercentage >= 75 },
    { threshold: 100, label: 'Onboarding Complete', icon: 'Trophy', reached: completionPercentage >= 100 }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
          <Icon name="BarChart3" size={24} color="var(--color-primary)" strokeWidth={2.5} />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-foreground">Your Progress</h2>
          <p className="text-sm text-muted-foreground">Track your onboarding journey</p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium text-foreground">Tasks Completed</span>
            <span className="text-2xl font-bold text-primary">
              {completedTasks}/{totalTasks}
            </span>
          </div>
          <div className="relative h-3 bg-muted rounded-full overflow-hidden">
            <div
              className="absolute top-0 left-0 h-full bg-gradient-to-r from-primary to-warning rounded-full transition-all duration-500 ease-spring shadow-glow"
              style={{ width: `${completionPercentage}%` }}
            />
          </div>
          <span className="text-xs text-muted-foreground">{completionPercentage}% Complete</span>
        </div>

        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium text-foreground">XP Earned</span>
            <span className="text-2xl font-bold text-success">
              {earnedXP}/{totalXP}
            </span>
          </div>
          <div className="relative h-3 bg-muted rounded-full overflow-hidden">
            <div
              className="absolute top-0 left-0 h-full bg-gradient-to-r from-success to-accent rounded-full transition-all duration-500 ease-spring"
              style={{ width: `${xpPercentage}%` }}
            />
          </div>
          <span className="text-xs text-muted-foreground">{xpPercentage}% of Total XP</span>
        </div>
      </div>
      <div className="border-t border-border pt-6">
        <h3 className="text-sm font-semibold text-foreground mb-4 flex items-center gap-2">
          <Icon name="Award" size={16} color="var(--color-primary)" />
          Milestones
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {milestones?.map((milestone, index) => (
            <div
              key={index}
              className={`p-3 rounded-lg border transition-all duration-300 ${
                milestone?.reached
                  ? 'bg-success/10 border-success/30' :'bg-muted/10 border-muted/20'
              }`}
            >
              <div className="flex flex-col items-center text-center gap-2">
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center ${
                    milestone?.reached ? 'bg-success/20' : 'bg-muted/20'
                  }`}
                >
                  <Icon
                    name={milestone?.icon}
                    size={20}
                    color={milestone?.reached ? 'var(--color-success)' : 'var(--color-muted-foreground)'}
                    strokeWidth={2}
                  />
                </div>
                <div>
                  <p className="text-xs font-medium text-foreground">{milestone?.threshold}%</p>
                  <p className="text-xs text-muted-foreground">{milestone?.label}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProgressOverview;